import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { IdIssuanceVerifyFormInputs } from 'src/@types/pendingRespondentStatus';
import { usePendingRespondentApi } from 'src/api/usePendingRespondentApi';

type UseIdIssuanceForm = {
  token: string | null;
};

export const useIdIssuanceForm = ({ token }: UseIdIssuanceForm) => {
  const [canAgree, setCanAgree] = useState<boolean>(false);
  const { agree } = usePendingRespondentApi();
  const onSubmit: SubmitHandler<IdIssuanceVerifyFormInputs> = async (formData) => {
    if (!token) return;
    await agree(formData, token);
  };

  return {
    canAgree,
    setCanAgree,
    onSubmit,
  };
};
